import { render, staticRenderFns } from "./No15.vue?vue&type=template&id=06fe217c&scoped=true"
import script from "./No15.vue?vue&type=script&lang=js"
export * from "./No15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe217c",
  null
  
)

export default component.exports